import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { IMyDpOptions, IMyDateModel, IMyDate} from "mydatepicker";
import "../../../assets/semantic/semantic.min.js";

import { CompanyService } from "../../_services/company.service";
import { PlanningService } from "../../_services/planning.service";
import { PlanningPalettesService } from "../../_services/planning-palettes.service";
import { SecurityService } from "../../_services/security.service";
import { ExportService } from "../../_services/export.service";

import * as moment from 'moment';

declare var jQuery: any;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})

export class DashboardComponent implements OnInit {
  private total: number;
  private total_incidents: number;
  private marge: number = 0.00;
  private percent;
  private from;
  private to;
  private palettes;
  private planning_palettes;
  private plannings;
  private emissions: number = 0;

  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: "dd/mm/yyyy",
    openSelectorOnInputClick: true,
    editableDateField: false,
  };

  constructor(
    private service: PlanningService,
    private security: SecurityService,
    private company: CompanyService,
    private pps: PlanningPalettesService,
    private exportService: ExportService
  ) { }
  
  filters = new FormGroup({
    client_id: new FormControl(),
    warehouse_id: new FormControl(),
    transporter_id: new FormControl(),
    from: new FormControl(),
    to: new FormControl()

  })

  formatDate(date): string {
    moment.locale('fr');
    const formattedDate = moment(date, 'YYYY-MM-DD HH:mm:ss').format('ddd DD-MM-YYYY');
    return formattedDate || '';
  }
  
  
  setDate(): void {
    this.from = moment().startOf('month').format('YYYY-MM-D');
    this.to = moment().endOf('month').format('YYYY-MM-D');

    let startOfMonth = moment().startOf('month');
    let endOfMonth = moment().endOf('month');
    
    this.filters.patchValue(
    {
      from: {
        date: {
          year: startOfMonth.format('YYYY'),
          month: startOfMonth.format('MM'),
          day: startOfMonth.format('D')
        }
      },
      to: {
        date: {
          year: endOfMonth.format('YYYY'),
          month: endOfMonth.format('MM'),
          day: endOfMonth.format('D')
        }
      }
    });
  }
  ngOnInit() {
    this.setDate();

    this.getAll();
    //recuperation des palettes pr le dashboard
    this.getPalettes();

    this.filters.valueChanges.debounceTime(250).subscribe((value) => {
      if (value.from && value.from.formatted) {
        this.from = value.from.jsdate;
        value.from = value.from.formatted;
      }
      if (value.to && value.to.formatted) {
        this.to = value.to.jsdate;
        value.to = value.to.formatted;
      }

      this.getAll(value);
      this.getPalettes(value);
    });    
  }

  getPalettes(client = null) {
    let params = {};
    
    Object.assign(params, { from: this.from, to: this.to });
    
    if (client) {
      Object.assign(params, {
        client_id: client.client_id,
        warehouse_id: client.warehouse_id,
        transporter_id: client.transporter_id
      });
    }
  
    this.palettes = {
      total_chargees: 0,
      total_rendues: 0,
      total_livrees: 0,
      total_reprises: 0,
      solde_entrepot: 0,
      solde_transporteur: 0,
    };
    

    this.pps.getAllPalettes(params).subscribe((response) => {

      let palettes = this.palettes;

      this.planning_palettes = response.palettes.map(function (palette) {
        
        let solde_transporteur = (palette.rendues - palette.chargees);
        let solde_entrepot = (palette.livrees - palette.reprises);

        palettes.total_chargees += palette.chargees;
        palettes.total_rendues += palette.rendues;
        palettes.total_livrees += palette.livrees;
        palettes.total_reprises += palette.reprises;

        
        return {...palette, solde_transporteur, solde_entrepot, showDetails: false}
      });
      this.palettes.solde_entrepot = (this.palettes.total_livrees - this.palettes.total_reprises);
      this.palettes.solde_transporteur = (this.palettes.total_rendues - this.palettes.total_chargees);
    });
  }

  toggleVisibility(index) {
    this.planning_palettes[index].showDetails = !this.planning_palettes[index].showDetails;
  }


  getAll(client = null) {
    let params = {};
    this.emissions = 0;
    Object.assign(params, { from: this.from, to: this.to });
    if (client) {
      Object.assign(params, { client_id: client.client_id });
    }
    
    this.service.countAll(params).subscribe((total) => {
      let percent = 0;
      let reverse = 0;
      this.total = total.plannings.length;
      this.marge = 0;

      let incidents = total.plannings.filter((planning) => (planning.state == 1 || planning.incidents.length > 0));
      this.total_incidents = incidents.length;

      total.plannings.forEach(single => {
        
        if (single.buy_price && single.sell_price) {
          this.marge = this.marge + (single.sell_price - single.buy_price);
        }
        if (single.co2_emis) {
          this.emissions += parseFloat(single.co2_emis);
        }
      });

      this.marge = parseFloat(this.marge.toFixed(2));
        
      if (total.plannings.length > 0) {
        percent = Math.round((incidents.length *100)/ total.plannings.length );
        reverse = 100 - percent;
      }

      jQuery('#total').progress({
        percent: reverse
      });
      
    })
  }

  exportPalettesToExcel(): void {
    const exportData = this.planning_palettes.map(palette => ({
      'Numéro de transport': palette.planning.number,
      'Date de départ': this.formatDate(palette.planning.departure_date),
      'Client': palette.planning.client ? palette.planning.client.name : '',
      'Transporteur': palette.planning.transporter ? palette.planning.transporter.name : '',
      'Entrepôt de chargement': palette.warehouse ? palette.warehouse.name : '',
      'Entrepôt de livraison': palette.warehouse_shipping ? palette.warehouse_shipping.name : '',
      'Palettes chargées': palette.chargees,
      'Palettes rendues': palette.rendues,
      'Palettes livrées': palette.livrees,
      'Palettes reprises': palette.reprises,
      'Solde transporteur': palette.solde_transporteur,
      'Solde entrepôt': palette.solde_entrepot
    }));

    const fileName = `palettes_export_${moment().format('YYYY-MM-DD')}`;
    this.exportService.exportToExcel(exportData, fileName);
  }

}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/dashboard/dashboard.component.ts